<div class="d-flex align-items-center justify-content-between px-3 shadow-sm">
	<h4 style="margin: 0px">{{ pageTitleService.title$ | async }}</h4>
	<div class="mt-3" *ngIf="!isProduction">
		<h5 style="color: red">{{ environmentName }} ENVIRONMENT</h5>
	</div>
	<div class="d-flex flex-row align-items-center" style="gap: 0.75rem">
		<div style="cursor: pointer" routerLink="pages/shared-grid-layout" (click)="setPageTitle('Shared Grid Layout')">
			<i style="font-size: 1.5rem" class="fa fa-layer-group gold-font-color"></i>
		</div>
		<!-- Notification Bell with Dropdown -->
		<div style="position: relative" class="notification-dropdown-container">
			<div style="cursor: pointer; position: relative" (click)="toggleNotifications()">
				<i style="font-size: 1.5rem" class="fa fa-bell gold-font-color"></i>
				<!-- Notification Badge -->
				<span *ngIf="unreadAnnouncements > 0" class="notification-badge">
					{{ unreadAnnouncements > 9 ? '9+' : unreadAnnouncements }}
				</span>
			</div>

			<!-- Notifications Dropdown -->
			<div *ngIf="isNotificationsOpen" class="notification-dropdown">
				<div class="notification-dropdown-header">
					<strong>Announcements</strong>
					<span *ngIf="unreadAnnouncements > 0" style="font-size: 0.85rem; color: #666"
						>{{ unreadAnnouncements }} unread</span
					>
				</div>

				<!-- Announcements List -->
				<div class="scrollable-notifications">
					<div *ngIf="notifications && notifications.length > 0">
						<div
							*ngFor="let announcement of notifications.slice(0, 9)"
							class="notification-item"
							[ngClass]="{ unread: !announcement.isRead }"
							(click)="navigateToAnnouncements()"
						>
							<div class="notification-content">
								<!-- Unread indicator -->
								<div
									class="notification-unread-indicator"
									[ngStyle]="{ visibility: announcement.isRead ? 'hidden' : 'visible' }"
								></div>

								<div class="notification-text-container">
									<div class="notification-title">
										{{ announcement.title }}
									</div>
									<div class="notification-timestamp">
										{{ announcement.scheduledDate | relativeTime }}
									</div>
								</div>
							</div>
						</div>
					</div>

					<div *ngIf="!notifications || notifications.length === 0" class="p-3 text-center">
						<i>No announcements</i>
					</div>
				</div>

				<!-- View All Button -->
				<div class="notification-view-all-btn" (click)="navigateToAnnouncements()">
					<span class="notification-view-all-text">View All</span>
				</div>
			</div>
		</div>

		<!-- Vertical Separator -->
		<div style="width: 1px; height: 24px; background-color: #ddd; margin: 0 8px"></div>

		<!-- User Profile Dropdown -->
		<div style="position: relative; cursor: pointer" class="user-dropdown-container" (click)="toggleDropdown()">
			<div class="user-profile-trigger" [ngClass]="{ open: isDropdownOpen }">
				<div class="user-profile-info">
					<span class="user-profile-name">{{ user.fullName }}</span>
				</div>
				<i
					class="fa fa-chevron-down user-profile-chevron"
					[ngStyle]="{ transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)' }"
				></i>
			</div>

			<!-- Dropdown Menu -->
			<div *ngIf="isDropdownOpen" class="user-profile-dropdown">
				<div class="feature-btn">
					<span>New Sidebar</span>
					<div class="mt-1" style="transform: scale(0.75)">
						<p-inputSwitch [(ngModel)]="isNewLayout" (onChange)="layoutService.toggleLayout()"></p-inputSwitch>
					</div>
				</div>

				<div class="logout-btn" (click)="logout()">
					<i class="fa fa-sign-out-alt logout-icon"></i>
					<span class="logout-text">Logout</span>
				</div>
			</div>
		</div>
	</div>
</div>
